import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=7d622f5c&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lee/Developer/Auris/admin-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d622f5c')) {
      api.createRecord('7d622f5c', component.options)
    } else {
      api.reload('7d622f5c', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=7d622f5c&", function () {
      api.rerender('7d622f5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Sidebar.vue"
export default component.exports